import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import { Chart, registerables } from 'chart.js';

//import { Editor } from '@tinymce/tinymce-react';
import {leadCharts, leadreportstext} from '../../API/FetchCall';

const doughnutPieOptions = {
    responsive: true,
    animation: {
      animateScale: true,
      animateRotate: true
    }
  };    



class leadStats extends Component {

     constructor(props) {
        super(props);
        
        this.state = {
            textresults_quicklead:[],
            textresults_direct:[],
            totalAvgQ:0,
            totalAvgD:0,
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
        }

        this.showResults = this.showResults.bind(this);
        this.handleChange = this.handleChange.bind(this);

    }
    
    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    };
    


    componentDidMount() {

        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        let role = auth_data.role;
        this.setState({ vendor_id: vendor_id, role:role });
       
        let req_com = {
            url: 'leadchartthru'
        };

        leadCharts(JSON.stringify(req_com)).then(response => {
            if (response.status === 1) {
                this.setLeadChart_1(response.result);
            }
        });   

        let req_com_sixmonths = {
            url: 'leadcharts_by6months'
        };

        leadCharts(JSON.stringify(req_com_sixmonths)).then(response => {
            if (response.status === 1) {
                this.setLeadChart_2(response.result);
            }
        });   
        
        let req_com_quicklead = {
            url: 'leadcharts_quickleads'
        };
        leadreportstext(JSON.stringify(req_com_quicklead)).then(response => {
            if (response.status === 1) {
                this.setState({textresults_quicklead:response.result, totalAvgQ:response.totalAvgQ});
            }
        });   
      
        let req_com_direct = {
            url: 'leadcharts_direct'
        };
        leadreportstext(JSON.stringify(req_com_direct)).then(response => {
            if (response.status === 1) {
                this.setState({textresults_direct:response.result,totalAvgD:response.totalAvgD});
            }
        });  

    }

    componentDidUpdate() {
       // window.jQuery('.selectpicker').selectpicker('refresh')
    }

    setLeadChart_1 = (data) => {

        var ctx = document.getElementById('chartitem_1');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

        
        myChart.canvas.parentNode.style.width = '500px';

    }

    setLeadChart_2 = (data) => {

        var ctx = document.getElementById('chartitem_2');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

        
        myChart.canvas.parentNode.style.width = '500px';

    }

    showResults(){
 
        let req_com_quicklead = {
            url: 'leadcharts_quickleads',
            fromDate:this.state.fromDate,
            toDate:this.state.toDate
        };
        leadreportstext(JSON.stringify(req_com_quicklead)).then(response => {
            if (response.status === 1) {
                this.setState({textresults_quicklead:response.result, totalAvgQ:response.totalAvgQ});
            }
        });   
      
        let req_com_direct = {
            url: 'leadcharts_direct',
            fromDate:this.state.fromDate,
            toDate:this.state.toDate
        };
        leadreportstext(JSON.stringify(req_com_direct)).then(response => {
            if (response.status === 1) {
                this.setState({textresults_direct:response.result,totalAvgD:response.totalAvgD});
            }
        });  


    }

    render() {

         const {user_id, textresults_quicklead, textresults_direct, totalAvgQ, totalAvgD} = this.state;
        
        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Leads </h4>

                    
                  <div class="chartblock">

                        <div class="chartitemflexed">
                            <div class="chartblock_title">Weekly Leads Statistics</div>  

                            <div class="charblock_chart">

                                <canvas id="chartitem_1"></canvas>

                            </div>
                        </div>

                        <div class="chartitemflexed">
                            <div class="chartblock_title">Last 6 months Leads Statistics</div>  

                            <div class="charblock_chart">

                                <canvas id="chartitem_2"></canvas>

                            </div>
                        </div>
                  </div>  

                  <div class="avgstats">
                  <div class="flexed-align-btm padding20">
                  <div class="timeDateSelection">

                            <label>Select From Date</label>
                            <div class="dateSelection">
                                <input type="date" name="fromDate" class="inputcls" onChange={this.handleChange}/>
                            </div>
                   </div>
                   <div class="timeDateSelection">         

                            <label>Select To Date</label>
                            <div class="dateSelection">
                                <input type="date" name="toDate" class="inputcls"  onChange={this.handleChange}/>
                            </div>
                    </div>
                    <div class="timeDateSelection">
                            
                            <div class="dateSelection">
                                <input type="button" name="submit" class="btn btn-primary" value="GO" onClick={this.showResults}/>
                            </div>

                    </div>
                  </div>
                  <div class="textbasedReports">
                        <h3>Leads Generated From using mini form (articles/verticals)</h3> 

                            <div class="titlelineup">
                                <div class="itemlinedup-flexed-head">
                                        <div class="itemvalue_lead_total"><b>Visit</b></div>
                                        <div class="itemvalue_lead_type"><b>Page Type</b></div>
                                        <div class="itemvalue_lead_from"><b>Page Link</b></div>
                                </div>
                            </div>

                        {textresults_quicklead.map((item, index)=>{

                            return  <div class="titlelineup">
                                        <div class="itemlinedup-flexed">
                                                <div class="itemvalue_lead_total">{item.total}</div>
                                                <div class="itemvalue_lead_type">{item.pagetype}</div>
                                                <div class="itemvalue_lead_from">{item.pagefrom} <a href={item.pagefrom} target="_blank">view page</a></div>
                                        </div>
                                    </div>
                        })}
                  </div> 
                  

                  <div class="textbasedReports">
                        <h3>Leads Generated by clicking Links from Footers and Advertisements</h3> 

                            <div class="titlelineup">
                                <div class="itemlinedup-flexed-head">
                                        <div class="itemvalue_lead_total"><b>Visit</b></div>
                                        <div class="itemvalue_lead_type"><b>Page Type</b></div>
                                        <div class="itemvalue_lead_from"><b>Page Link</b></div>
                                </div>
                            </div>

                        {textresults_direct.map((item, index)=>{

                            return  <div class="titlelineup">
                            <div class="itemlinedup-flexed">
                                    <div class="itemvalue_lead_total">{item.total}</div>
                                    <div class="itemvalue_lead_type">{item.pagetype}</div>
                                    <div class="itemvalue_lead_from">{item.pagefrom} <a href={item.pagefrom} target="_blank">view page</a></div>
                            </div>
                            </div>

                        })}
                  </div> 

                  </div>

                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default leadStats;


// WEBPACK FOOTER //
// ./src/components/bewise/leadStats.jsx